var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b',[_vm._v("M"+_vm._s(_vm.item.mcodeStr))]),_vm._v(" "+_vm._s(_vm.item.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }